import React from 'react';
import { Input, Label } from 'reactstrap';

const FileUploader = ({
    files,
    onFileChange,
    onRemoveFile,
    onClearFiles,
    totalFileSize,
    maxTotalSize,
    isLoading,
    multiple = true,
    accept = ".jpg,.jpeg,.png",
    label = "Загрузить файл",
    disabled = false,
    showSizeCounter = true
}) => {
    const handleFileSelect = (e) => {
        onFileChange(e);   // передаём событие в родительский обработчик
        e.target.value = ''; // сброс для возможности повторной загрузки тех же файлов
    };

    return (
        <div className="file-upload-wrapper">
            <Input
                type="file"
                id="file-upload"
                multiple={multiple}
                accept={accept}
                onChange={handleFileSelect}
                disabled={disabled || (maxTotalSize && totalFileSize >= maxTotalSize)}
                className="visually-hidden"
            />
            <Label
                for="file-upload"
                className="voice-record-button custom-button dt1520-button active-dt1520-button view-button"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        document.getElementById('file-upload').click();
                    }
                }}
            >
                {label}
            </Label>

            {files.length > 0 && (
                <div className="upload-file-list-container">
                    <div className="file-list-header message-file-list-header">
                        <p>Загруженные файлы:</p>
                        <button
                            className="default-button active-dt1520-button dt1520-button clear-all-btn no-margin-top"
                            onClick={onClearFiles}
                            aria-label="Очистить все файлы"
                            type="button"
                            disabled={disabled}
                        >
                            Очистить все
                        </button>
                    </div>
                    <ul className="file-list">
                        {files.map((file, index) => (
                            <li key={index}>
                                <div className="file-info">
                                    <span className="file-name">{file.name}</span>
                                    <span className="file-size">
                                        ({Math.round(file.size / 1024)} KB)
                                    </span>
                                </div>
                                <button
                                    className="file-remove"
                                    onClick={() => onRemoveFile(index)}
                                    aria-label="Удалить файл"
                                    type="button"
                                    disabled={disabled}
                                >
                                    <span className="close-icon">&times;</span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {showSizeCounter && maxTotalSize && (
                <div className={`counter ${totalFileSize >= maxTotalSize ? 'red-color' : ''}`}>
                    Общий размер файлов: {Math.round(totalFileSize / 1024)} KB /{' '}
                    {Math.round(maxTotalSize / 1024)} KB
                </div>
            )}
        </div>
    );
};

export default FileUploader;